import { render, staticRenderFns } from "./PostListItemCategory.vue?vue&type=template&id=08a05972&scoped=true&"
import script from "./PostListItemCategory.vue?vue&type=script&lang=js&"
export * from "./PostListItemCategory.vue?vue&type=script&lang=js&"
import style0 from "./PostListItemCategory.vue?vue&type=style&index=0&id=08a05972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a05972",
  null
  
)

export default component.exports